import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const customersManagement = createSlice({
  name: "customersManagement",
  initialState: {
    customers: {},
    keys: [],
    customersDetails: {},
    searchCriteria: {
      searchText: "",
      isActive: null,
      industry: null,
    },
    showError: false,
    error: null,
  },
  reducers: {
    customersRecived: (customersManagement: any, { payload }: PayloadAction<any>) => {
      const data = payload.body || [];
      data.forEach((item: any) => {
        customersManagement.customers[item.id] = item;
        customersManagement.keys = [...customersManagement.keys, item.id];
      });
      customersManagement.customersDetails = {};
    },

    customerUpdated: (customersManagement: any, { payload }: PayloadAction<any>) => {
      const data = payload.body;
      if (customersManagement.customers[data.id]) {
        customersManagement.customers[data.id] = {
          ...customersManagement.customers[data.id],
          isActive: !data.isActive,
        };
      }
    },

    deleteCustomersById: (customersManagement: any, { payload }: PayloadAction<any>) => {
      const customerId = payload.customerId;
      customersManagement.keys = customersManagement.keys.filter((x: any) => x !== customerId);
      delete customersManagement.customers[customerId];
    },

    setCustomer: (customersManagement: any, { payload }: PayloadAction<any>) => {
      customersManagement.customersDetails = payload.data;
    },

    // ✅ Fixed to handle both camelCase and PascalCase keys
    setSearchCriteria: (customersManagement, { payload }) => {
      const body = payload.body ?? {};

      const searchText = body.searchText ?? body.SearchText ?? "";
      const isActive = body.isActive ?? body.IsActive ?? null;
      const industry = body.industry ?? body.Industry ?? null;

      customersManagement.searchCriteria = {
        searchText,
        isActive,
        industry,
      };
    },

    // ✅ Reset to proper null defaults
    resetSearchCriteria: (customersManagement: any) => {
      customersManagement.searchCriteria = {
        searchText: "",
        isActive: null,
        industry: null,
      };
    },

    setError: (customersManagement: any, { payload }: PayloadAction<any>) => {
      customersManagement.error = payload.response;
      customersManagement.showError = true;
    },
  },
});

export const {
  customersRecived,
  setCustomer,
  setSearchCriteria,
  resetSearchCriteria,
  deleteCustomersById,
  setError,
} = customersManagement.actions;

export default customersManagement.reducer;

//#region :: Selectors
export const getcustomersData = (state: any) => state.customersManagement.customers;
export const getCustomer = (state: any) => state.customersManagement.customersDetails;
export const getcustomersKeys = (state: any) => state.customersManagement.keys;
export const getSearchCriteria = (state: any) => state.customersManagement.searchCriteria;
export const getShowError = (state: any) => state.customersManagement.showError;
export const getError = (state: any) => state.customersManagement.error;

export const customersSelectors = {
  getcustomersData,
  getcustomersKeys,
  getSearchCriteria,
  getShowError,
  getError,
};
//#endregion
